import React, { useEffect, useState } from "react";
import Navbar from "../../components/navbar/navbar";
import Select from 'react-select';
import { CheckBoxData, countryData } from "../../utils/UserDataCheckBox";
import Footer from "../../components/footer";
import { IoMdClose } from "react-icons/io";
import { loadStripe } from '@stripe/stripe-js';
import {
    PaymentElement,
    Elements,
    useStripe,
    useElements,
} from '@stripe/react-stripe-js';
import AddSpaceForm from "./AddSpaceForm";
import { useLocation } from "react-router-dom";
import { payment } from "../../services/ApiServices";

const AddSpace = () => {
    const location = useLocation();
    const userProfileString = localStorage?.getItem('userProfile');
    const userDetail: any = userProfileString ? JSON.parse(userProfileString) : null;
    console.log("location", location);
    const orderAmount: any = localStorage.getItem("orderAmount");
    console.log("orderAmount", orderAmount);

    // const [orderAmount, setOrderAmount] = useState<any>(0);
    const [propertyImage, setPropertyImage] = useState<any[]>([]);
    const [clientSecret, setClientSecret] = useState<any>();

    console.log("propertyImage", propertyImage);

    const status = [
        { value: '1', label: 'For Lease' },
        { value: '0', label: 'For Sale' },
    ];

    const handleUploadImageChange = (event: any) => {
        const fileObj = event.target.files && URL.createObjectURL(event.target.files[0]);
        if (!fileObj) {
            return;
        } else {
            setPropertyImage([...propertyImage, fileObj])
            // setProfilePhoto(fileObj)
            // uploadImage(event.target.files[0])
        }
    };

    const removeImage = (id: any) => {
        setPropertyImage(propertyImage?.filter((image, index) => index !== id))
    }

    const fetchPaymentSheetParams = async () => {
        payment(userDetail?.api_token).then((res) => {
            console.log("payment success", res);
            const { paymentIntent, ephemeralKey, customer } = res;;
            setClientSecret(res.paymentIntent);
            // setOrderAmount(res.order_amount)
            return paymentIntent
        }).catch((err) => {
            console.log("payment error", err);
        })
    }

    useEffect(() => {
        fetchPaymentSheetParams()
    }, [])
    const key = process.env.REACT_APP_TEST_KEY;
    console.log("KEY===>", key);

    const stripePromise = loadStripe('pk_live_51Kn4wWHm5Cb6qxlD5aGE8r4gzCCrYa2TDZfRMOGaCRccLu5kj8vhf3nRdWOB77GF6mnf8f4MJPcsaW6fSaO84utH001PIJIMu7');
    console.log("stripePromise", stripePromise);
    const amount = parseInt(orderAmount)
    // const options: any = {
    //     mode: 'payment',
    //     amount: parseInt(orderAmount),
    //     currency: 'usd',
    // };
    console.log("orderAmount", orderAmount, amount);

    const options = {
        appearance: {
            theme: 'stripe',
            variables: {
                colorPrimary: '#0570de',
                colorBackground: '#ffffff',
                colorText: '#30313d',
                colorDanger: '#df1b41',
                fontFamily: 'Ideal Sans, system-ui, sans-serif',
                spacingUnit: '2px',
                borderRadius: '4px',
            },
        },
    };


    console.log("clientSecret", clientSecret);

    return (
        <>
            {/* <Elements stripe={stripePromise} options={options}>
                <AddSpaceForm />
            </Elements> */}
            <Navbar transparent={false} />
            <div className="page-title">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <h2 className="ipt-title">Post Property</h2>
                        </div>
                    </div>
                </div>
            </div>

            <section className="gray-simple">
                <div className="container">
                    <Elements
                        stripe={stripePromise}
                        key={clientSecret || "default-key"}
                        options={clientSecret ?
                            {
                                appearance: { theme: 'stripe' },
                                clientSecret
                            } : undefined}
                    // options={{
                    //     appearance: {
                    //         theme: 'stripe',
                    //     },
                    //     clientSecret: clientSecret
                    // }}
                    >
                        <AddSpaceForm spaceItem={location?.state} orderAmount={orderAmount} />
                    </Elements>

                </div>

            </section>
            <Footer />
        </>)
};

export default AddSpace;
